import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: m[1] });
        setUser(res.data.user);
        const target = res.data.user?.role === "admin" ? "/admin" : "/home";
        window.history.replaceState(null, "", window.location.pathname);
        navigate(target, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error("[AuthCallback] failed:", e);
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-zinc-50">
      <div className="mt-tiny text-zinc-500">Signing you in...</div>
    </div>
  );
}
